import { clearBullets } from '../entities/bullets.js';
import { clearDrones } from '../entities/drones.js';
import { clearEnemies } from '../entities/enemies.js';
import { clearEnemyShots } from '../entities/enemy_shots.js';
import { resetPlayer } from '../entities/player.js';
import { clearBossArena } from '../entities/boss.js';
import { initWaveDirector } from './waves.js';
import { resetGame } from './state.js';
import { addScore as addLeaderboardScore } from '../ui/leaderboard.js';
import { hideLobby, showLobby } from '../ui/lobby.js';
import { fmt } from '../util/math.js';
import { clearParticles } from '../vfx/particles.js';
import { clearTracers } from '../vfx/tracers.js';
import { submitWavedashRun } from '../platform/wavedash.js';

const $ = (id) => document.getElementById(id);

let control = null;

export function initRunControl(options = {}) {
  control = {
    player: options.player,
    game: options.game,
    onRestart: options.onRestart || (() => {}),
    savedGameOver: false,
    gameOver: $('gameOver'),
    finalScore: $('finalScore'),
    finalWave: $('finalWave'),
    finalKills: $('finalKills'),
    copy: $('gameOverCopy'),
  };
  $('retryBtn')?.addEventListener('click', () => restartRun('playing'));
  $('finishLobbyBtn')?.addEventListener('click', () => restartRun('lobby'));
  return control;
}

export function showGameOverIfNeeded() {
  if (!control?.game || control.game.mode !== 'gameover') return false;
  if (control.savedGameOver) return true;
  const { game } = control;
  control.savedGameOver = true;
  addLeaderboardScore({
    name: $('playerName')?.value || 'Runner',
    score: game.score,
    wave: game.wave,
    kills: game.kills,
  });
  submitWavedashRun(game);
  setText(control.finalScore, fmt(game.score));
  setText(control.finalWave, String(game.wave));
  setText(control.finalKills, fmt(game.kills));
  setText(control.copy, `Score ${fmt(game.score)} · Wave ${game.wave} · choose Retry or return to Lobby for another hero.`);
  control.gameOver?.classList.remove('hidden');
  $('hud')?.classList.add('hidden');
  $('weaponHud')?.classList.add('hidden');
  return true;
}

export function restartRun(mode = 'playing') {
  if (!control) return;
  clearEnemies();
  clearBullets();
  clearEnemyShots();
  clearParticles();
  clearTracers();
  clearDrones();
  clearBossArena();
  resetPlayer();
  resetGame({ mode });
  initWaveDirector(control.game);
  control.savedGameOver = false;
  control.gameOver?.classList.add('hidden');
  if (mode === 'lobby') showLobby();
  else hideLobby();
  control.onRestart(mode);
}

function setText(element, value) {
  if (element) element.textContent = value;
}
